<template>
    <Header :isLoginPage="true" />
    <ForgetPassword></ForgetPassword>
    <Footer></Footer>
</template>

<script>
  import Header from '@/components/Header.vue'
  import ForgetPassword from '@/components/user/ForgetPassword.vue'
  import Footer from '@/components/Footer.vue'

import {mapGetters,mapActions} from 'vuex'
  export default {
    components: {
      Header,
        ForgetPassword,
        Footer
    },
      computed: {
        ...mapGetters([
            'isMobile'
        ]),
    },
  }
</script>

